import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../../shared-components/LoadingSpinner";

const CompanyIntegrations: React.FC = () => {
  const { companyId, subid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new route
    if (subid) {
      navigate(
        `/companies/${companyId}/subcompany/${subid}/settings/integrations`
      );
    } else {
      navigate(`/companies/${companyId}/settings/integrations`);
    }
  }, [companyId, subid, navigate]);

  return <LoadingSpinner />;
};

export default CompanyIntegrations;
